import React from "react";
var __jsx = React.createElement;
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Container, Button } from "../_global";
import { openLoginModal } from "../../reducers/user";
var UnauthenticatedMessage = styled.div.withConfig({
  displayName: "Unauthenticated__UnauthenticatedMessage",
  componentId: "sc-8p0fr0-0"
})(["display:flex;align-items:center;justify-content:center;text-align:center;min-height:50vh;"]);
var Unauthenticated = function Unauthenticated(_ref) {
  var _ref$openLoginModal = _ref.openLoginModal,
    handlePress = _ref$openLoginModal === void 0 ? function () {} : _ref$openLoginModal;
  return __jsx(Container, {
    wideView: true
  }, __jsx(UnauthenticatedMessage, null, __jsx("div", null, __jsx("p", null, "Please login to view this page"), __jsx(Button, {
    primary: true,
    onPress: function onPress() {
      return handlePress(window.location.href);
    }
  }, "Log in"))));
};
var mapDispatchToProps = {
  openLoginModal: openLoginModal
};
export default connect(null, mapDispatchToProps)(Unauthenticated);